import { render, staticRenderFns } from "./MyResponsesPage.vue?vue&type=template&id=b61efc80&scoped=true"
import script from "./MyResponsesPage.vue?vue&type=script&lang=js"
export * from "./MyResponsesPage.vue?vue&type=script&lang=js"
import style0 from "./MyResponsesPage.vue?vue&type=style&index=0&id=b61efc80&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61efc80",
  null
  
)

export default component.exports